import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { ProvPayerApiService } from '../../services/prov-payer-api.service';
import { ProvPayerService } from '../../services/prov-payer.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-company-regulator',
  templateUrl: './company-regulator.component.html',
  styleUrls: ['./company-regulator.component.css']
})
export class CompanyRegulatorComponent implements OnInit {
  showRegulator:boolean=true;
  @Input() formGroupName!: string;
  @Input() submitted: boolean = false;
  @Input('uniQueId') uniQueId:number = 1;
  @Input('isThirdPartyComp') isThirdPartyComp: boolean = false;
  regulatorForm!: FormGroup;
  countryList:any[]=[];
  regulatorList:any[]=[];
  dummyData= [
    {
      id: "1",
      name: 'option1',
    },
    {
      id:"2",
      name: 'option2',
    },
  ];
  constructor(
    private rootFormGroup: FormGroupDirective,
    private provPayerApiService : ProvPayerApiService
  ) { }

  ngOnInit(): void {
    this.getMasterLists();
    this.regulatorForm = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;
  }
  getMasterLists() {
    forkJoin([
      this.provPayerApiService.getRegulatorList(),
      this.provPayerApiService.getCountryList(),
    ]).subscribe({
      next: (responseList) => {
        this.regulatorList = responseList[0];
        this.countryList = responseList[1];
      }
    })
  }
  selectedValue(event: any, formElem: string) {
    
    if (!event) {
      this.regulatorForm.controls[formElem].patchValue(null);
    }  
      this.regulatorForm.controls[formElem].patchValue(event);
  }
  // getcountryList() {
  //   this.provPayerApiService.getCountryList().subscribe({
  //     next: (response) => { 
  //       if (response) {
  //         this.countryList = response?.data; 
  //       } 
  //     },
  //     error: (error) => {
  //       // treat error
  //     },
  //     complete: () => {
  //       // define on request complete logic
  //       // 'complete' is not the same as 'finalize'!!
  //       // this logic will not be executed if error is fired
  //     }
  //   })
    
  // }
  // getRegulatorList() {
  //   this.provPayerApiService.getRegulatorList().subscribe({
  //     next: (response) => { 
  //       if (response) {
  //         this.regulatorList = response?.data; 
  //       } 
  //     },
  //     error: (error) => {
        
  //     },
  //     complete: () => {
      
  //     }
  //   })
    
  // }
}
